<script setup lang="ts">
import { useSlots } from 'vue'

import { BoxComponent, FlexComponent } from '@/ui-library'
import TitleComponent from '@/ui-library/atoms/TitleComponent.vue'

type OptionItem = { label: string; value: string | number }
defineProps<{
  title?: string
  options: OptionItem[]
  name?: string
}>()
defineSlots<{
  tooltip(): void
  option(props: { option: OptionItem }): void
}>()
defineEmits(['change'])
const slots = useSlots()

const value = defineModel<string | number>('modelValue')
</script>
<template>
  <BoxComponent>
    <FlexComponent justify="space-between" :gap="8">
      <TitleComponent v-if="title" :title="title">
        <template v-if="slots.tooltip" #tooltip>
          <slot name="tooltip" />
        </template>
      </TitleComponent>
      <el-radio-group v-model="value" size="large" :name="name">
        <el-radio-button v-for="item in options" :key="item.value" :value="item.value">
          <slot name="option" :option="item">{{ item.label }}</slot>
        </el-radio-button>
      </el-radio-group>
    </FlexComponent>
  </BoxComponent>
</template>
<style lang="scss" scoped>
:deep(.el-radio-group) {
  border-radius: 40px;
  padding: 2px;
  background: var(--secondary-8);
}
:deep(.el-radio-button) {
  border-radius: 40px;
  background: none;

  .el-radio-button__inner {
    border-radius: 40px;
    border: none;
    box-shadow: none;
    padding: 8px 12px;
    font-size: 12px;
    line-height: 16px;
  }
}
:deep(.el-radio-button__inner) {
  color: var(--primary);
  background: none;
}
:deep(.el-radio-button__original-radio) {
  &:checked + .el-radio-button__inner {
    background: var(--inverted);
    color: var(--primary);
  }
}
</style>
<style lang="scss">
.el-radio-button {
  --el-radio-button-checked-text-color: var(--primary);
}
</style>
